<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  .map-container{
    height: 450px;
  }
  @media (min-width: 760px) {
    .container-gauge{
      height: 350px;
    }
  }
</style>
<template>
    <div>
      <div class="item-grid-view vx-row match-height mt-4">
          <div class="lg:w-1/3 sm:w-1/2 w-full p-4">
              <div class="w-full grid-view-item">
                  <vx-card class="grid-view-item mb-base overflow-hidden" v-if="response != null">
                      <gridPrincipalItem
                        img="co2"
                        :name="response.alias"
                        :description="$t('Labels.Alias')"
                        :name2="response.serial"
                        :description2="$t('Labels.Serie')"
                      ></gridPrincipalItem>
                      <div class="absolute right-0 top-0">
                          <vs-button  @click="deviceStatistics()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                          </vs-button>
                          <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="goToConfig()" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                          </vs-button>
                      </div>
                      <vs-divider/>
                      <valueItem deviceType="V" :description="$t('Labels.MeterVirus')" img="co2" :value="parseFloat(response.ppm_current || 0).toFixed(2)" unit="ppm" :min="'600'" :max="'3000'" :warning="'1000'"></valueItem>
                      <valueItem deviceType="C" :description="$t('Labels.airQuality')" img="co2" :value="parseFloat(response.ppm_current || 0).toFixed(2)" unit="ppm" :min="'1000'" :max="'3000'" :warning="'1600'"></valueItem>
                      <valueItem deviceType="T" :description="$t('Labels.Temperature')" img="temperature" :value="parseFloat(response.temp_current || 0).toFixed(2)" unit="°C" :min="response.temp_min" :max="response.temp_max"></valueItem>
                      <valueItem deviceType="H" :description="$t('Labels.Humidity')" img="humedad" :value="parseFloat(response.hum_current || 0).toFixed(2)" unit="%" :min="response.hum_min" :max="response.hum_max"></valueItem>
                      <alertRelay :status="response.relay1_state === '1'? true: false" name="Relay 1" :device="response.relay1_device"/>
                      <alertRelay :status="response.relay2_state === '1'? true: false" name="Relay 2"  :device="response.relay2_device"/>
                      <valueItem :description="$t('Labels.Date')" img="fecha" :value="response.updated_at"></valueItem>
                  </vx-card>
              </div>

          </div>
          <div class="vx-col lg:w-2/3 sm:w-2/3 w-full p-4">
              <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                  <div class="avatar-info-container">
                      <span class="account-number">
                          {{$t("Labels.DeviceLocation")}}
                      </span>
                      <feather-icon
                          icon="EditIcon"
                          @click="editMap = true"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="!editMap  && $store.state.AppActiveUser.userRole === 'MA'"/>
                      <feather-icon
                        icon="SaveIcon"
                        @click="saveMap()"
                        class="float-right cursor-pointer"
                        svgClasses="hover:text-primary"
                        v-if="editMap"/>
                      <div class="map-container basic-example" v-if="status_mapa">
                          <l-map :center="center" :zoom="zoom" v-if="response != null">
                              <l-tile-layer :attribution="attribution" :url="url">
                              </l-tile-layer>
                              <l-marker :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                  <l-icon :icon-anchor="staticAnchor">
                                      <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                  </l-icon>
                              </l-marker>
                          </l-map>
                      </div>
                      <div class="mt-2">
                        <label>{{$t('Labels.References')}}:</label>{{response.label_location  }}
                      </div>
                  </div>
              </vx-card>
          </div>
      </div>
      <div class="container-alerts" v-if="gauges.ppm_max">
        <div class="flex-1 p-4">
          <vx-card class="container-gauge">
            <riskAlert class="mt-10"
              :min="0"
              :max="3000"
              :alertMin="600"
              :warning="1000"
              :alertMax="3000"
              :title="$t('Labels.MeterVirus')"
              :value="parseFloat(gauges.ppm_current) || 0"
              unit="ppm"
              type="V"
              deviceType='C'
            />
          </vx-card>
        </div>
        <div class="flex-1 p-4">
          <vx-card class="container-gauge">
            <riskAlert class="mt-10"
              :min="0"
              :max="3000"
              :alertMin="1000"
              :warning="1600"
              :alertMax="3000"
              :title="$t('Labels.airQuality')"
              :value="parseFloat(gauges.ppm_current) || 0"
              unit="ppm"
              type="Q"
              deviceType='C'
            />
          </vx-card>
        </div>
        <div class="flex-1 p-4">
          <vx-card class="container-gauge">
            <!--<gauge
              :min="parseInt(limits.temperature.min)"
              :max="parseInt(limits.temperature.max)"
              :alertMin="parseInt(gauges.temp_min)"
              :alertMax="parseInt(gauges.temp_max)"
              :title="$t('Labels.Temperature')"
              :value="parseFloat(gauges.temp_current).toFixed(2) || 0"
              unit="°C"
            />-->
            <riskAlert class="mt-10"
              :min="parseFloat(limits.temperature.min)"
              :max="parseFloat(limits.temperature.max)"
              :alertMin="parseInt(gauges.temp_min)"
              :alertMax="parseInt(gauges.temp_max)"
              :title="$t('Labels.Temperature')"
              :value="parseFloat(gauges.temp_current).toFixed(2) || 0"
              unit="°C"
              deviceType='T'
            />
          </vx-card>
        </div>
        <div class="flex-1 p-4">
          <vx-card class="container-gauge">
            <!--<gauge
              :min="parseInt(limits.humidity.min)"
              :max="parseInt(limits.humidity.max)"
              :alertMin="parseInt(gauges.hum_min)"
              :alertMax="parseInt(gauges.hum_max)"
              :title="$t('Labels.Humidity')"
              :value="parseFloat(gauges.hum_current).toFixed(2) || 0"
              unit="%"
            />-->
            <riskAlert class="mt-10"
              :min="parseFloat(limits.humidity.min)"
              :max="parseFloat(limits.humidity.max)"
              :alertMin="parseInt(gauges.hum_min)"
              :alertMax="parseInt(gauges.hum_max)"
              :title="$t('Labels.Humidity')"
              :value="parseFloat(gauges.hum_current).toFixed(2) || 0"
              unit="%"
              deviceType='H'
            />
          </vx-card>
        </div>
      </div>
      <div class="item-grid-view vx-row match-height mt-4 p-4">
          <div class="w-full">
              <vx-card class="grid-view-item mb-base">
                  <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                  <vs-divider/>
                  <!-- success -->
                  <div class="text-right mt-2 m-10">
                    <div class="mt-2">
                      <div class="text-2xl">{{$t('Labels.TypePowerRelay')}}</div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': controlPower }">{{$t('Labels.Automatic')}}</div>
                      <div class="inline-block align-middle mx-2">
                        <vs-switch v-model="controlPower" @click="powerRelay" color="success"/>
                      </div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlPower }">{{$t('Labels.Manually')}}</div>
                    </div>
                  </div>
                  <div class="container-alerts" v-if="response != null && controlPower">
                    <div class="text-center mt-2 m-10">
                      <div class="text-2xl">Relay 1</div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': relayPower1 }">{{$t('Labels.Off')}}</div>
                      <div class="inline-block align-middle mx-2">
                        <vs-switch v-model="relayPower1" color="success"/>
                      </div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': !relayPower1 }">{{$t('Labels.On')}}</div>
                    </div>
                    <div class="text-center mt-2 m-10">
                      <div class="text-2xl">Relay 2</div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': relayPower2 }">{{$t('Labels.Off')}}</div>
                      <div class="inline-block align-middle mx-2">
                        <vs-switch v-model="relayPower2" color="success"/>
                      </div>
                      <div class="inline-block align-middle font-bold" :class="{'text-grey': !relayPower2 }">{{$t('Labels.On')}}</div>
                    </div>
                  </div>
                  <div class="text-center" v-if="controlPower">
                    <div class="submit-button-container">
                      <vs-button @click="formSubmit" class="submit-button">
                          {{$t("Labels.Save")}}
                      </vs-button>
                    </div>
                  </div>
                  <div class="container-alerts" v-if="response && !controlPower">
                      <minMaxItem
                        v-if="response.ppm_current"
                        :title="$t('Labels.Co2')"
                        :min="response.ppm_min"
                        :max="response.ppm_max"
                        unit="ppm"
                        img="co2_gray"
                        :url="`co2_devices/${this.uuid}/update`"
                        paramMin="ppm_min"
                        paramMax="ppm_max"
                        type="PUT"
                        :limitMin="limits.co2.min || 0"
                        :limitMax="limits.co2.max || 0"
                        :time="parseInt(response.co2_time)"
                        :unity="response.co2_time_unity"
                        paramTime="co2_time"
                        paramUnity="co2_time_unity"
                        @update="update"
                      />
                      <minMaxItem
                        v-if="response.temp_current"
                        :title="$t('Labels.Temperature')"
                        :min="response.temp_min"
                        :max="response.temp_max"
                        unit="°C"
                        img="temperature_gray"
                        :url="`co2_devices/${this.uuid}/update`"
                        paramMin="temp_min"
                        paramMax="temp_max"
                        type="PUT"
                        :limitMin="limits.temperature.min || 0"
                        :limitMax="limits.temperature.max || 0"
                        :time="parseInt(response.tem_time)"
                        :unity="response.tem_time_unity"
                        paramTime="tem_time"
                        paramUnity="tem_time_unity"
                        @update="update"
                      />
                      <minMaxItem
                        v-if="response.hum_current"
                        :title="$t('Labels.Humidity')"
                        :min="response.hum_min"
                        :max="response.hum_max"
                        unit="%"
                        img="humedad_gray"
                        :url="`co2_devices/${this.uuid}/update`"
                        paramMin="hum_min"
                        paramMax="hum_max"
                        type="PUT"
                        :limitMin="limits.humidity.min || 0"
                        :limitMax="limits.humidity.max || 0"
                        :time="parseInt(response.hum_time)"
                        :unity="response.hum_time_unity"
                        paramTime="hum_time"
                        paramUnity="hum_time_unity"
                        @update="update"
                      />
                  </div>
              </vx-card>
          </div>
      </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import { request } from '@/request.js'
import { empty } from '@/helpers.js'
import alertRelay from '@/components/alertRelay/alertRelay.vue'
// import gauge from '@/components/gauge/gauge.vue'
import riskAlert from '@/components/riskAlert/riskAlert.vue'

/* global L:true */

const DATA = {
  code: 200,
  data: {
    uuid: 'cdfbacef-3540-41b5-aae3-448bcd330df4',
    deveui: '0011223344556677',
    serial: '1111111',
    alias: 'sensor 1 co2',
    label_location: 'en la biblioteca planta baja',
    notes: 'alguna nota extra no obligatiora',
    ppm_current: '800',
    ppm_max: '1000',
    ppm_min: '500',
    temp_current: '28.01',
    temp_max: '30.01',
    temp_min: '25.01',
    hum_current: '50',
    hum_max: '60',
    hum_min: '30',
    relay1_state: '0',
    relay2_state: '1',
    latlong: '20.6738686,-103.3704324',
    created_at: '2021-08-20 17:29:11',
    updated_at: '2021-08-23 11:08:06',
    time: 15,
    unity: 'minutes'
  },
  limits: {
    temperature: {
      min: 0,
      max: 100
    },
    humidity: {
      min: 0,
      max: 100
    },
    ppm: {
      min: 0,
      max: 5000
    }
  },
  msg: 'Ok'
}
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    minMaxItem,
    valueItem,
    gridPrincipalItem,
    alertRelay,
    // gauge,
    riskAlert
  },

  data () {
    return {
      controlPower: false,
      relayPower1: false,
      relayPower2: false,
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      draggable: true,
      staticAnchor: [12, 27],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      editMap: false,
      limits: {
        temperature: {
          min: 0,
          max: 100
        },
        humidity: {
          min: 0,
          max: 100
        },
        co2: {
          min: 0,
          max: 5000
        }
      },
      data: DATA,
      gauges: [],
      response: {
        alias: '',
        serial: '',
        ppm_current: '',
        ppm_min: '',
        ppm_max: '',
        temp_current: '',
        temp_min: '',
        temp_max: '',
        hum_current: '',
        hum_min: '',
        hum_max: '',
        relay1_device: '',
        relay2_device: '',
        updated_at: '',
        label_location: '',
        co2_time: '',
        co2_time_unity: '',
        tem_time: '',
        tem_time_unity: '',
        hum_time: '',
        hum_time_unity: ''
      }
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `co2_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.limits = response.data.limits
        this.gauges = response.data.data
        this.controlPower = (response.data.data.type_power_relay === 'M')
        this.relayPower1 = (response.data.data.enabled_power_relay1 === '1')
        this.relayPower2 = (response.data.data.enabled_power_relay2 === '1')
        if (!empty(this.response.latlong)) {
          const [lat, long] = this.response.latlong.split(',')
          this.marker = L.latLng(lat, long)
          this.center = L.latLng(lat, long)
          this.status_mapa = true
        }
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `co2_devices/${this.uuid}/update`,
        method: 'PUT',
        params: {
          latlong: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/co/config/${this.uuid}`
    },
    deviceStatistics () {
      window.location.href = `/co/statistics/${this.uuid}`
    },
    async formSubmit (e) {
      e.preventDefault()
      const params = {
        url: `co2_devices/${this.uuid}/update`,
        method: 'PUT',
        params: {
          enabled_power_relay1: (this.relayPower1 ? 1 : 0),
          enabled_power_relay2: (this.relayPower2 ? 1 : 0)
        }
      }
      await request(params)
    },
    async powerRelay () {
      const params = {
        url: `co2_devices/${this.uuid}/update`,
        method: 'PUT',
        params: {
          type_power_relay: (this.controlPower ? 'A' : 'M')
        }
      }
      await request(params)
    },
    async update () {
      this.gauges = []
      this.getResponse()
    }
  },
  sockets: {
    co2 (payload) {
      if (this.uuid === payload.uuid) {
        this.response.ppm_current = payload.ppm_current
        this.response.hum_current = payload.hum_current
        this.response.temp_current = payload.temp_current
        this.response.relay1_state = payload.relay1_state
        this.response.relay2_state = payload.relay2_state
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
  .vue2leaflet-map .leaflet-shadow-pane {
    display: none !important;
  }

  .vs-input--label {
    padding: 0;
  }
</style>
